import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { UserService } from '../../services';
import { Modal, Button, Snackbar, Tooltip } from '@material-ui/core';
import {
    Send as SendIcon,
    CheckBox as CheckBoxIcon,
    CheckBoxOutlineBlank,
} from '@material-ui/icons';
import { useNotification } from '../../contexts/NotificationContext';
import green from '@material-ui/core/colors/green';
import Alert from '@material-ui/lab/Alert';
import { humanizeSnakeCaseString } from '../../utils/formatters';
import { isSuccessfulResponse } from '../../utils/responseHelpers';
import { ROLE_PRESETS, isPresetSelected, togglePreset, isPresetLocked, lockingPresetName } from '../../utils/constants';

const useStyles = makeStyles((theme) => ({
    paper: {
        position: 'absolute',
        left: "30%",
        top: "15%",
        width: '40vw',
        height: '65vh',
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        overflowY: 'scroll',
    },
    editButton: {
        backgroundColor: green[400],
        marginTop:'4px',
        marginRight:'4px',
        textTransform: 'none',
    },
    rolesItem: {
        display: 'flex',
        alignItems: 'center',
    },
    rolesText: {
        alignItems: 'center',
        display: 'inline-flex',
        marginLeft: '10px',
    },
    submit: {
        marginTop: '10px',
    },
}));

const EditRolesCell = (props) => {
    const classes = useStyles();
    const [selectedRoles, setSelectedRoles] = useState(props.currentRoles);
    const [showEditRoles, setShowEditRoles] = useState(false);
    const { createErrorNotification } = useNotification();
    const [showWaitMessage, setShowWaitMessage] = useState(false);

    const handleOpen = () => {
        setSelectedRoles(props.currentRoles);
        setShowEditRoles(true);
    };
    const handleClose = () => {
        setShowEditRoles(false);
        setSelectedRoles(props.currentRoles);
    };

    const handleCheckboxChange = (role) => {
        setSelectedRoles((prevRoles) => {
            if (prevRoles.includes(role)) {
                return prevRoles.filter((r) => r !== role);
            }
            return [...prevRoles, role];
        });
    };

    const handlePresetChange = (preset) => setSelectedRoles((prev) => togglePreset(preset, prev));

    const handleSubmit = async () => {
        try {
            const response = await UserService.updateUserRoles({
                id: props.id,
                roles: selectedRoles,
            });

            if (isSuccessfulResponse(response)) {
                setShowEditRoles(false);
                setShowWaitMessage(true);
                setTimeout(() => window.location.reload(), 10000);
            } else {
                throw new Error("Failed to save User Role change");
            }
        } catch (err) {
            createErrorNotification("Failed to save User Role change");
        }
    };

    const closeWaitMessage = () => {
        setShowWaitMessage(false);
    }

    return (
        <>
            <Snackbar open={showWaitMessage} autoHideDuration={3000} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
                <Alert onClose={closeWaitMessage} severity="success">
                    {"Your changes will appear in a few seconds. They take effect after the user logs out and logs back in."}
                </Alert>
            </Snackbar>
            <Button onClick={handleOpen} className={classes.editButton} >
                Edit
            </Button>
            <Modal open={showEditRoles} onClose={handleClose} >
                <div className={classes.paper}>
                    <h3>Edit Roles for {props.email_address}</h3>
                    <h4>Permission Presets</h4>
                    {
                        ROLE_PRESETS.map((preset) => {
                            if (isPresetLocked(preset, selectedRoles)) {
                                const name = lockingPresetName(preset, selectedRoles);
                                return (
                                    <div key={preset.name} className={classes.rolesItem}>
                                        <Tooltip title={name ? `Included in ${name}` : 'Included in another selected preset'}>
                                            <CheckBoxIcon color="disabled" />
                                        </Tooltip>
                                        <p className={classes.rolesText}>{ preset.name }</p>
                                    </div>
                                );
                            }
                            return (
                                <div key={preset.name} className={classes.rolesItem}>
                                    {
                                        isPresetSelected(preset, selectedRoles)
                                        ? <CheckBoxIcon onClick={() => handlePresetChange(preset)} />
                                        : <CheckBoxOutlineBlank onClick={() => handlePresetChange(preset)} />
                                    }
                                    <p className={classes.rolesText}>{ preset.name }</p>
                                </div>
                            );
                        })
                    }
                    <h4>Roles</h4>
                    {
                        props.rolesData.map((role) => (
                            <div key={role} className={classes.rolesItem}>
                                {
                                    selectedRoles.includes(role)
                                    ? <CheckBoxIcon onClick={() => handleCheckboxChange(role)} />
                                    : <CheckBoxOutlineBlank onClick={() => handleCheckboxChange(role)} />
                                }
                                <p className={classes.rolesText}>{ humanizeSnakeCaseString(role) }</p>
                            </div>
                        ))
                    }
                    <Button className={classes.submit}
                            variant="contained"
                            color="primary"
                            endIcon={<SendIcon/>}
                            onClick={handleSubmit}>
                        Submit
                    </Button>
                </div>
            </Modal>
        </>
    );
};

export default EditRolesCell;
